/**
 * Kalós — Product Main interactions.
 * Size selector: clicking a size button updates the hidden variant id
 * input inside the product form and the displayed selected state.
 * Qty controls: +/- buttons adjust the qty input, min 1.
 * Gallery thumbs: clicking a thumbnail swaps the main image src/alt
 * and updates the active thumb state.
 * No framework dependency, vanilla DOM only — matches the rest of the
 * Kalós custom sections (kalos-home.js uses the same pattern).
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.k-pdp-buybox').forEach(function (buybox) {
      var variantInput = buybox.querySelector('.k-pdp-variant-input');
      var sizeButtons = buybox.querySelectorAll('.k-pdp-size-opt');

      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('disabled')) return;
          var variantId = btn.getAttribute('data-variant-id');
          if (variantInput && variantId) {
            variantInput.value = variantId;
          }
          sizeButtons.forEach(function (b) { b.classList.remove('k-pdp-size-sel'); });
          btn.classList.add('k-pdp-size-sel');
        });
      });

      var qtyInput = buybox.querySelector('.k-pdp-qty-input');
      var qtyMinus = buybox.querySelector('.k-pdp-qty-minus');
      var qtyPlus = buybox.querySelector('.k-pdp-qty-plus');

      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, current - 1);
        });
      }
      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = current + 1;
        });
      }
    });

    document.querySelectorAll('.k-pdp-gallery').forEach(function (gallery) {
      var mainImg = gallery.querySelector('.k-pdp-main-img img');
      var thumbs = gallery.querySelectorAll('.k-pdp-thumb');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (mainImg && fullSrc) {
            mainImg.setAttribute('src', fullSrc);
            mainImg.setAttribute('alt', alt);
          }
          thumbs.forEach(function (t) { t.classList.remove('k-pdp-thumb-active'); });
          thumb.classList.add('k-pdp-thumb-active');
        });
      });
    });
  });
})();
